import { objectParticle } from './korean';
import type { Answer } from './compute';
import type { TaskSpec } from './task';
import { taskNeedsTable } from './task';

export type CompletionVerification = {
  complete: boolean;
  issues: string[];
  /**
   * 결과를 버려야 할 만큼 심각한 것들.
   *
   * 표가 아예 없으면 요청을 지키지 못한 것이다. 반면 열 이름이 계획과 다른 것은
   * 다 만들어 놓은 표와 보고서를 버릴 이유가 못 된다 — 답변에 적어 주고 넘긴다.
   */
  blocking: string[];
};

function normalized(value: string): string {
  return value.replace(/[\s_-]/g, '').toLocaleLowerCase();
}

/** 답변이 그럴듯한지가 아니라 사용자가 요청한 결과 계약을 실제로 충족했는지 본다. */
export function verifyCompletion(task: TaskSpec, answer: Answer): CompletionVerification {
  const blocking: string[] = [];
  const issues: string[] = [];
  // 이 문구는 답변 끝에 그대로 붙어 사용자가 읽는다. 우리 말이 아니라 그 사람 말로 쓴다.
  if (task.unresolved.length) {
    blocking.push(`${objectParticle(task.unresolved.join(', '))} 알려 주시면 더 정확하게 낼 수 있습니다`);
  }
  if (taskNeedsTable(task) && !answer.table) blocking.push('상세 내역 표는 만들지 못했습니다');
  if (answer.table && task.artifact?.requiredColumns.length) {
    // **사람이 쓰는 말과 표의 열 이름이 늘 같지는 않다.** `현장` 을 요청했는데 표는
    // `현장명` 이라 적는다 — 글자가 똑같기를 요구했더니 열이 멀쩡히 있는 자료를 두고
    // `현장 항목은 이 자료에 없습니다` 라고 답했다. 한쪽이 다른 쪽을 담고 있으면 같다.
    const present = answer.table.columns.map(normalized);
    const missing = task.artifact.requiredColumns.filter((column) => {
      const wanted = normalized(column);
      if (!wanted) return false;
      return !present.some((name) => (wanted.length >= 2 && name.includes(wanted))
        || (name.length >= 2 && wanted.includes(name)));
    });
    if (missing.length) issues.push(`${missing.join(', ')} 항목은 이 자료에 없습니다`);
  }
  issues.unshift(...blocking);
  return { complete: issues.length === 0, issues, blocking };
}

export class IncompleteTaskError extends Error {
  constructor(readonly verification: CompletionVerification) {
    super(`작업 완료 검증 실패: ${verification.issues.join(' / ')}`);
    this.name = 'IncompleteTaskError';
  }
}
